import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { getFormValues, initialize } from 'redux-form';
import { withRouter } from 'react-router';

import _ from 'lodash';

import * as siteActions from 'State/sites/actions';

import { Filter, Main } from 'Containers';
import { ApiResultMessage, LoadingPage } from 'Components';
import FileConfigurations from 'Common/FileConfigurations';
import {
  FileFieldEnum,
  ImportScheduleEnum,
  ImportPreviewFieldEnum,
} from 'Common/FieldEnum';
import { toastError } from 'Common/ToastHelper';
import {
  AUTO_IMPORT_SETUP,
  FILE_CONFIGURATIONS_FORM_NAME,
} from 'Common/FormEnum';

import { ImportPreview } from './../../ImportPreview';
import { AutoImportSetupForm } from './AutoImportSetupForm';

import { MPWApi } from 'API/MPWApi';
import { columnsOptions } from './../../fixtures';
import { validateColumnData } from './../../ImportStudentHelper';
import * as ImportStudentSelectors from './../../state/selectors';
import * as actions from './../../state/actions';
import { NUMBER_OF_PREVIEW_ROWS } from './../../helpers/Constants';
import { resetDirty } from 'State/dirtyTracking/actions';

let ImportStudentConfigValues = {};

class AutoImportSetupContainer extends Component {
  static path = '/importstudents/autoimportsetup/:id?';
  state = {
    file: '',
    defaultMealStatusValue: 4,
    showDialog: false,
    showDeleteDialog: false,
    importConfirmed: false,
  };

  async componentDidMount() {
    const {
      dispatch,
      importStudentReady,
      importStudentNotReady,
      initializeMappingData,
      getSites,
      match,
      clearAddedMappingDataAction,
    } = this.props;
    const importTypeId = parseInt(match.params.id, 10);
    importStudentNotReady();
    await getSites();
    MPWApi.importStudentsApi
      .loadAllAPIRequest(dispatch, importTypeId)
      .then((responses) => {
        initializeMappingData();
        importStudentReady();
        this.props.resetDirty();
      });
    clearAddedMappingDataAction();
  }

  componentWillUnmount() {
    this.props.clearAddedMappingDataAction();
    this.props.clearStudentHeaderAction();
  }

  componentDidUpdate(prevProps, prevState) {
    const { studentHeader: oldStudentHeader = { Data: [] } } = prevProps;
    const { studentHeader = { Data: [] }, addColumnMapping } = this.props;
    // Checks to add mapping to preview table
    if (oldStudentHeader.Data.length !== studentHeader.Data.length) {
      addColumnMapping(studentHeader.Data);
    }
  }

  uploadAnotherFile = () => {
    const {
      studentHeader = { Data: [] },
      addColumnMapping,
      clearAddedMappingDataAction,
    } = this.props;

    if (studentHeader.Data.length) {
      addColumnMapping(studentHeader.Data);
    } else {
      clearAddedMappingDataAction();
    }
    this.setState({ file: '' });
  };

  changeDelimiter = (delimiter) => {
    const { importConfigFormValues } = this.props;
    const { file } = this.state;

    this.getFilePreview({
      delimiter,
      file,
      fileEncoding: importConfigFormValues[FileFieldEnum.FileEncoding],
      recordCount: NUMBER_OF_PREVIEW_ROWS,
    });
  };

  postFile = (file) => {
    const { fileConfigFormValues, importConfigFormValues } = this.props;

    this.setState({ file: file });
    this.getFilePreview({
      delimiter: fileConfigFormValues[FileFieldEnum.FileSeparatorRadio],
      fileEncoding: importConfigFormValues[FileFieldEnum.FileEncoding],
      file,
      recordCount: NUMBER_OF_PREVIEW_ROWS,
    });
  };

  updatePreviewData = (value, i) => {
    const { columnMapping, importConfigFormValues, addColumnMapping } =
      this.props;
    const longestLineLength = Math.max(
      this.fileData.map((list) => list.length)
    );
    const [success, columnMappingData, column] = validateColumnData(
      value,
      i,
      columnMapping,
      columnsOptions,
      importConfigFormValues[FileFieldEnum.Id],
      longestLineLength
    );

    if (!success) {
      toastError(`You have already selected the field ${column.text}`);
    }

    addColumnMapping(columnMappingData);

    return success;
  };

  saveConfig = async () => {
    let {
      columnMapping,
      fileConfigFormValues,
      importConfigFormValues,
      finalLanguageMappedValues,
      finalMealMappedValues,
      finalSiteMappedValues,
      gradeMappedValues,
      importStudentsConfig,
      postImportStudentsAction,
    } = this.props;

    let fileValues = fileConfigFormValues;
    let importValues = importConfigFormValues;
    let languageValues = _.map(finalLanguageMappedValues, function (o) {
      return _.omit(o, 'mappedValue');
    });
    let mealValues = _.map(finalMealMappedValues, function (o) {
      return _.omit(o, 'mappedValue');
    });
    let siteValues = _.map(finalSiteMappedValues, function (o) {
      return _.omit(o, 'mappedValue');
    });
    let gradeValues = _.map(gradeMappedValues, function (o) {
      return _.omit(o, 'mappedValue');
    });
    let delimiterValue = fileValues[FileFieldEnum.FileSeparatorRadio];
    ImportStudentConfigValues = {
      Id: importValues[FileFieldEnum.Id],
      FileFormat: 0,
      Description: 'AUTO',
      FileName: importValues[FileFieldEnum.FileName],
      Delimiter: delimiterValue || ',',
      IsFirstRowHeader: importValues[FileFieldEnum.HeaderRowRadio],
      IsWithdrawNotInFile:
        importValues[FileFieldEnum.WithdrawNotInFileRowRadio],
      EnrolledValue: importValues[FileFieldEnum.EnrolledValue],
      WithdrawnValue: importValues[FileFieldEnum.WithdrawnValue],
      EnrollStatus: importValues.mealStatusDropDown,
      UseMappedValue: importValues[FileFieldEnum.UseMappedValue],
      DC_DefaultCaseType: importStudentsConfig.DC_DefaultCaseType,
      DC_ImportTypeId: importStudentsConfig.DC_ImportTypeId,
      FileEncoding: importValues[FileFieldEnum.FileEncoding],
    };

    let FinalObj = {
      ImportStudentHeader: ImportStudentConfigValues,
      LanguageMapping: languageValues,
      MealsStatusMapping: mealValues,
      SiteMapping: siteValues,
      GradeMapping: gradeValues,
      ImportStudentDetailsList: columnMapping,
    };

    FinalObj = {
      ImportStudentHeader: ImportStudentConfigValues,
      LanguageMapping: languageValues,
      MealsStatusMapping: mealValues,
      SiteMapping: siteValues,
      GradeMapping: gradeValues,
      ImportStudentDetailsList: columnMapping,
      ImportSchedule: {
        Hour: importValues[ImportScheduleEnum.Hour],
        Minute: importValues[ImportScheduleEnum.Minute],
        AMorPM: importValues[ImportScheduleEnum.AMorPM],
        DaysOfTheWeek: importValues[ImportScheduleEnum.DaysOfTheWeek],
      },
    };

    await postImportStudentsAction(FinalObj);

    if (
      FinalObj.ImportStudentHeader.Id === 0 &&
      this.props.importResponse &&
      this.props.importResponse.Data.Message ===
        'Configuration saved successfully.'
    ) {
      this.props.history.replace(
        `/importstudents/autoimportsetup/${this.props.importResponse.Data.Data}`
      );
    }
  };

  getMainProps = () => {
    return {
      toolbox: {
        formName: AUTO_IMPORT_SETUP,
        backButtonProps: {
          shown: true,
          path: '/importstudents',
        },

        saveButtonProps: {
          content: 'Save',
        },
        shown: true,
      },
    };
  };

  onFileEncodingChange = (e, option) => {
    const { fileConfigFormValues } = this.props;
    const { file } = this.state;

    this.getFilePreview({
      delimiter: fileConfigFormValues[FileFieldEnum.FileSeparatorRadio],
      fileEncoding: option,
      file,
      recordCount: NUMBER_OF_PREVIEW_ROWS,
    });
  };

  getFilePreview({ delimiter, fileEncoding, file, recordCount }) {
    const { postImportStudentsFile } = this.props;

    if (file) {
      const formData = new FormData();
      formData.append(ImportPreviewFieldEnum.Delimiter, delimiter);
      formData.append(ImportPreviewFieldEnum.FileEncoding, fileEncoding);
      formData.append(ImportPreviewFieldEnum.ImportFile, file);
      formData.append(ImportPreviewFieldEnum.RecordCount, recordCount);
      postImportStudentsFile(formData);
    }
  }

  get fileData() {
    const { importStudents } = this.props;

    return _.get(importStudents, 'Data', []) || [];
  }

  render() {
    const {
      ready,
      dispatch,
      fileConfigFormValues = {},
      importConfigFormValues,
      importStudentsConfig,
      importStudents = {},
      clearImportStudentsErrors,
      clearImportStudentsData,
      setImportStudentsErrors,
      notificationSystem,
      languages,
      languageDataMapped,
      languageOptions,
      finalMealMappedValues,
      finalLanguageMappedValues,
      mappingData,
      columnMapping,
      importSchedule,
      siteOptions,
      sitesMappedDescriptions,
      sitesMapped,
      gradeOptions,
      gradesMappedDescriptions,
      gradesMapped,
      importSettingsData,
    } = this.props;
    const importStudentsErrors = _.get(importStudents, 'Errors', []) || [];

    const { fileSeparatorRadio = ',' } = fileConfigFormValues;

    let {
      UseMappedValue,
      FileFormat,
      Delimiter,
      IsFirstRowHeader = true,
      FileEncoding,
    } = importStudentsConfig;

    if (!Delimiter) Delimiter = fileSeparatorRadio;

    return (
      <Fragment>
        {!ready && <LoadingPage />}
        <Filter
          title={'Import Students/Adults'}
          style={{ marginBottom: '40px' }}
        />
        <Main {...this.getMainProps()}>
          {ready && (
            <AutoImportSetupForm
              initialValues={{
                [FileFieldEnum.Id]: importStudentsConfig.Id,
                [FileFieldEnum.WithdrawnValue]:
                  importStudentsConfig.WithdrawnValue,
                [FileFieldEnum.EnrolledValue]:
                  importStudentsConfig.EnrolledValue,
                [FileFieldEnum.UseMappedValue]: UseMappedValue,
                [FileFieldEnum.HeaderRowRadio]:
                  importStudentsConfig.IsFirstRowHeader,
                [FileFieldEnum.WithdrawNotInFileRowRadio]:
                  importStudentsConfig.IsWithdrawNotInFile,
                [FileFieldEnum.FileName]: importStudentsConfig.FileName,
                [FileFieldEnum.MealStatusDropDown]: 4,
                [ImportScheduleEnum.DaysOfTheWeek]:
                  importSchedule.Data.Data.DaysOfTheWeek,
                [ImportScheduleEnum.Hour]: importSchedule.Data.Data.Hour,
                [ImportScheduleEnum.Minute]: importSchedule.Data.Data.Minute,
                [ImportScheduleEnum.AMorPM]: importSchedule.Data.Data.AMorPM,
                [FileFieldEnum.FileEncoding]: FileEncoding,
              }}
              isFirstRowHeader={
                !importConfigFormValues
                  ? fileConfigFormValues && fileConfigFormValues.headerRowRadio
                  : importConfigFormValues.headerRowRadio
              }
              dispatch={dispatch}
              languages={languages}
              languageDataMapped={languageDataMapped}
              languageOptions={languageOptions}
              useMappedValue={_.get(
                importConfigFormValues,
                FileFieldEnum.UseMappedValue,
                false
              )}
              fileSettings={importStudentsConfig}
              mappingData={mappingData}
              finalLanguageMappedValues={finalLanguageMappedValues}
              finalMealMappedValues={finalMealMappedValues}
              onSubmit={this.saveConfig}
              siteOptions={siteOptions}
              sitesMappedDescriptions={sitesMappedDescriptions}
              sitesMapped={sitesMapped}
              gradeOptions={gradeOptions}
              gradesMappedDescriptions={gradesMappedDescriptions}
              gradesMapped={gradesMapped}
              onFileEncodingChange={this.onFileEncodingChange}
              importSettingsData={importSettingsData}
            />
          )}
          <FileConfigurations
            dispatch={dispatch}
            formValues={fileConfigFormValues}
            changeDelimiter={this.changeDelimiter}
            displayDropZone={this.fileData.length === 0}
            handleFilePreview={this.postFile}
            clearImportStudentsErrors={clearImportStudentsErrors}
            setImportStudentsErrors={setImportStudentsErrors}
            initialValues={{
              [FileFieldEnum.FileFormatId]: FileFormat,
              [FileFieldEnum.FileSeparatorRadio]: Delimiter,
              [FileFieldEnum.HeaderRowRadio]: IsFirstRowHeader,
            }}
          />
          {!!importStudentsErrors.length && (
            <ApiResultMessage result={importStudents} />
          )}
          {!!this.fileData.length && (
            <ImportPreview
              dispatch={dispatch}
              fileData={this.fileData}
              updatePreviewData={this.updatePreviewData}
              header={columnMapping}
              notificationSystem={notificationSystem}
              clearImportStudentsData={clearImportStudentsData}
              uploadAnotherFile={this.uploadAnotherFile}
            />
          )}
        </Main>
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  ...actions,
  getSites: siteActions.getSitesAction,
  resetDirty,
  initialize,
};

const mapStateToProps = (state) => {
  const { ImportStudentState } = state;
  return {
    fileConfigFormValues: getFormValues(FILE_CONFIGURATIONS_FORM_NAME)(state),
    importConfigFormValues: getFormValues(AUTO_IMPORT_SETUP)(state),
    importStudents: ImportStudentState.importStudents,
    importStudentsConfig: ImportStudentState.importStudentsConfiguraton.Data,
    languages: ImportStudentSelectors.getLanguages(state),
    finalLanguageMappedValues: ImportStudentState.newLanguageMappingData,
    finalMealMappedValues: ImportStudentState.newMealMappingData,
    finalSiteMappedValues: ImportStudentState.newSiteMappingData,
    gradeMappedValues: ImportStudentState.gradeMappingData,
    importResponse: ImportStudentState.importResponse,
    studentHeader: ImportStudentState.importStudentHeader,
    ready: ImportStudentState.ready,
    columnMapping: ImportStudentState.columnMapping,
    importSchedule: ImportStudentState.importSchedule,
    siteOptions: ImportStudentSelectors.getSiteOptions(state),
    sitesMappedDescriptions:
      ImportStudentSelectors.getSitesMappedDescriptions(state),
    sitesMapped: ImportStudentSelectors.getSitesMapped(state),
    gradeOptions: ImportStudentSelectors.getGradeOptions(state),
    gradesMappedDescriptions:
      ImportStudentSelectors.getGradesMappedDescriptions(state),
    gradesMapped: ImportStudentSelectors.getGradesMapped(state),
    languageOptions: ImportStudentSelectors.getLanguageOptions(state),
    languageDataMapped: ImportStudentSelectors.getMappedLanguageData(state),
    importSettingsData: ImportStudentState.importSettingsData,
  };
};

const AutoImportSetup = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AutoImportSetupContainer)
);

export { AutoImportSetup };



// WEBPACK FOOTER //
// ./src/pages/importstudents/subpages/autoimportsetup/AutoImportSetup.js